import './WinRateBar.css';

interface WinRateBarProps {
  allyRate: number;
  enemyRate: number;
}

export function WinRateBar({ allyRate, enemyRate }: WinRateBarProps) {
  const allyPercent = Math.round(allyRate * 100 * 10) / 10;
  const enemyPercent = Math.round(enemyRate * 100 * 10) / 10;

  return (
    <div className="win-rate-bar">
      <div className="win-rate-header">
        <h3>予測勝率</h3>
        <div className="win-rate-values">
          <div className="ally-rate">
            <span className="label">味方</span>
            <span className="value">{allyPercent.toFixed(1)}%</span>
          </div>
          <div className="enemy-rate">
            <span className="label">敵</span>
            <span className="value">{enemyPercent.toFixed(1)}%</span>
          </div>
        </div>
      </div>
      <div className="win-rate-progress">
        <div
          className="ally-bar"
          style={{ width: `${allyPercent}%` }}
        />
        <div
          className="enemy-bar"
          style={{ width: `${enemyPercent}%` }}
        />
      </div>
    </div>
  );
}
